import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "fs_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export async function adminLogin(email, password) {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  setToken(res.data.token);
  return res.data;
}

export async function adminMe() {
  const res = await axios.get(`${API}/auth/me`, authHeaders());
  return res.data;
}

export async function listEnquiries() {
  const res = await axios.get(`${API}/contact`, authHeaders());
  return res.data;
}

export async function setEnquiryHandled(id, handled) {
  const res = await axios.patch(`${API}/contact/${id}`, { handled }, authHeaders());
  return res.data;
}

export async function deleteEnquiry(id) {
  const res = await axios.delete(`${API}/contact/${id}`, authHeaders());
  return res.data;
}
